import React from "react";
import ReactHtmlParser from "react-html-parser";
import { FEED_DETAILS } from "../../../../constants/route-constants";
import { DATE_FORMATS, MEDIA_TYPES } from "../../../../constants/app-constant";
import { formatDate, groupBy } from "../../../../utility/common-methods";
import ArticleTags from "../../News/ArticleTags";

export default function PrintAndOnlineFavouriteFeedItem({
  isPrint,
  isOnline,
  feed,
  editionList = [],
  newsDetails,
  allArticleList,
  onFeedSelect,
  singleNewsGroup,
  isNewsDetailsMain,
  other_edition_url_html,
  selectedFeeds,
  forEmbedArticles,
}) {
  if (!feed) {
    return null;
  }
  const {
    headline,
    publication,
    source,
    edition,
    article_id,
    client_id,
    entity_id,
    website_type,
    website_url,
    page_nos,
    publish_date,
    Forclient_id,
    language,
  } = feed;

  const handleArticleClick = (e, article) => {
    e.preventDefault();
    e.stopPropagation();
    let correctedId = article_id;
    if (article) {
      correctedId = article.article_id;
    }
    if (allArticleList)
      localStorage.setItem("articleIdList", JSON.stringify(allArticleList));

    if (isPrint) {
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/${
          MEDIA_TYPES.PRINT_MV
        }/${client_id || Forclient_id}-${correctedId}-${entity_id}`,
        "_blank"
      );
    }

    if (isOnline) {
      if (newsDetails || website_type === "International") {
        window.open(website_url);
      } else {
        window.open(
          `https://${window.location.host}${FEED_DETAILS}/${
            MEDIA_TYPES.ONLINE_MV
          }/${client_id || Forclient_id}-${correctedId}-${entity_id}`,
          "_blank"
        );
      }
    }
  };

  const renderEditionDetails = () => {
    if (isNewsDetailsMain && other_edition_url_html) {
      const { host, protocol } = window.location;
      const newHost = `${protocol}//${host}`;
      let newUrls = other_edition_url_html
        .replaceAll("http://clientportal.conceptbiu.com", newHost)
        .replaceAll("https://clientportal.conceptbiu.com", newHost)
        .replaceAll("href", 'class="nav-item nav-link" href')
        .replaceAll(" | ", "");

      let activeEdition = newUrls.match(
        /^[\*\s\w]*|[^\>]+(?=\<a )|[\*\s\w]*$/gs
      );
      if (activeEdition && activeEdition.length > 0) {
        const str = activeEdition.find((i) => i);
        newUrls = newUrls.replace(
          str,
          `<span class="nav-item active">${str}</span>`
        );
      }
      return <>{ReactHtmlParser(newUrls)}</>;
    }

    const showSingleEdition =
      (Array.isArray(singleNewsGroup) && singleNewsGroup.length == 0) ||
      isOnline;

    return (
      <>
        {showSingleEdition ? (
          <span className="editions activeEdition">
            {edition || (isOnline ? "Online Web" : "Print")}
          </span>
        ) : (
          singleNewsGroup.map((el, index) => {
            const { edition, abbreviation } = el;
            const editionFaceValue = abbreviation
              ? abbreviation.toUpperCase()
              : edition;

            return (
              <>
                <span
                  className="link"
                  onClick={(e) => handleArticleClick(e, el)}
                >
                  {editionFaceValue || "NA"}
                </span>
                {index < singleNewsGroup.length - 1 && ", "}
              </>
            );
          })
        )}
      </>
    );
  };

  const isSingleFeedSelected = () => {
    const tempArr =
      selectedFeeds &&
      selectedFeeds.filter(
        (f) => f.article_id == feed.article_id && f.entity_id == feed.entity_id
      );
    return tempArr && tempArr.length;
  };

  return (
    <div className="innerFeedItem">
      <div className="headlineWrapper">
        <label className="headlineLabel clickable" onClick={(e) => handleArticleClick(e)}>
          {headline}
        </label>
        {!forEmbedArticles && (
          <div className="rightContainer">
            <ul className="dropDownContainer">
              <ArticleTags
                article={feed}
                singleNewsGroup={singleNewsGroup}
                mediaType={isOnline ? "online" : "print"}
                isSingleFeedSelected={isSingleFeedSelected()}
                showFavouriteTag
                isPrintAndOnline
              />
            </ul>
          </div>
        )}
      </div>

      <ul className="card-entities">
        {isOnline ? (
          <li className="publication">
            <span className="label-span">Website :</span>{" "}
            <span
              className="data-span link"
              onClick={() => window.open(website_url)}
            >
              {publication}
            </span>
          </li>
        ) : (
          <li className="publication">
            <span className="label-span">Publication :</span>{" "}
            <span className="data-span">{publication}</span>
          </li>
        )}
        <li className="source">
          <span className="label-span">Source :</span>{" "}
          <span className="data-span">{source}</span>
        </li>
        {isOnline ? (
          <li className="languae">
            <span className="label-span">Language :</span>{" "}
            <span className="data-span">{language}</span>
          </li>
        ) : (
          <li className="edition">
            <span className="label-span">Edition :</span>{" "}
            <span className="data-span">{renderEditionDetails()}</span>
          </li>
        )}
        {isPrint && (
          <li className="pageNum">
            <span className="label-span">Page No :</span>{" "}
            <span className="data-span">{page_nos}</span>
          </li>
        )}
        <li className="publishDate">
          <span className="label-span">Publish Date :</span>{" "}
          <span className="data-span">
            {formatDate(new Date(publish_date), DATE_FORMATS.DDMMYYYY_dash)}
          </span>
        </li>
      </ul>
    </div>
  );
}
